import React from 'react';

import { AccountScreenContainer, AccountScreenTitle } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { SkeletonLoadingContentLG } from './AccountSkeletonLoading';

export const AccountOrdersLoading = () => {
  const { t } = useLocalizationContext();

  return (
    <AccountScreenContainer screen="orders">
      <AccountScreenTitle title={t('account.orders.title')} />

      {/* Orders */}
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
    </AccountScreenContainer>
  );
};
